import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { useNonprofitFundingSourcesLogic } from './hooks/useNonprofitFundingSourcesLogic';
import { NonprofitFundingSourcesForm } from './NonprofitFundingSourcesForm';

export const EddNonprofitFundingSources = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading, optionsList } = useNonprofitFundingSourcesLogic();
  const reactiveOptions = formMethods.watch(
    EddEmbeddedFields.EDD_NONPROFIT_FUNDING_SOURCES_SELECTED
  );

  return (
    <StepPageWrapper
      formMethods={formMethods}
      handleSubmit={formMethods.handleSubmit(handleSubmit)}
      isLoading={isLoading}
      heading={tCommon('sectionTitles.businessDetails')}
      text={t('organic.nonprofitFundingSources.instruction')}
      textCustomStyle='text-text-main-primary text-[16px] mt-[24px] whitespace-pre-line'
      content={t('organic.nonprofitFundingSources.title')}
      headingContainerCustomStyle='!mb-[24px]'>
      <FormProvider {...formMethods}>
        <NonprofitFundingSourcesForm reactiveOptions={reactiveOptions} optionsList={optionsList} />
      </FormProvider>
    </StepPageWrapper>
  );
};
